import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import { ROLES } from "../utils/enums";
// import { DashboardData } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;

};

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<CommonResponseType & { data: any }, void>({
      query: () => ({
        url: END_POINTS.dashboardData,
        method: "GET",
      }),
    }),

    changeGraphStatus: builder.query<CommonResponseType & { data: any }, {type: string, graphFor: number}>({
      query: ({type, graphFor}) => ({
        url: `${END_POINTS.changeGraphStatus}?graphFor=${graphFor}&type=${type}`,
        method: "GET",
      }),
    }),
 
    getGraphCSV: builder.query<
      CommonResponseType & { data: any },
      { endpoint: string }
    >({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "GET",
      }),
    }),
    getCSV: builder.query<
      CommonResponseType & { data: any },
      { endpoint: string }
    >({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "GET",
      }),
    }),
      analyticsExport: builder.query<CommonResponseType & { data: any }, void>({
        query: () => ({
          url: `${END_POINTS.exportEarningGraph}`,
          method: "GET",
        }),
      }),
   
  }),
});
export const {
  useLazyGetDashboardQuery,
useLazyGetCSVQuery,
  useLazyGetGraphCSVQuery,
  useLazyChangeGraphStatusQuery,
  useAnalyticsExportQuery,
  useLazyAnalyticsExportQuery
  
} = dashboardApi;
